module.exports = __webpack_public_path__ + "img/new14-3.65512da2.jpg";